import { reducerWithInitialState } from 'typescript-fsa-reducers'

import LoginState from '../states/LoginSessionState'
import { App, Login, Toolbar } from '../actions'

export const initialState: LoginState = {
  mobileVersion: undefined,
  credentials: null,
  user: null,
  loginModal: false,
  loginLoading: false,
  loginErrors: {},
  signUpModal: false,
  signUpLoading: false,
  signUpErrors: {}
}

export default reducerWithInitialState(initialState)
  .case(App.launched, (state, { mobileVersion }) => ({
    ...state,
    mobileVersion
  }))
  .case(Login.updateCredentials, (state, payload) => ({
    ...state,
    credentials: payload
  }))
  .case(Login.loadUser.done, (state, payload) => ({
    ...state,
    user: payload.result
  }))
  .case(Login.loginClick, state => ({
    ...state,
    loginModal: true
  }))
  .case(Login.loginClose, state => ({
    ...state,
    loginModal: false
  }))
  .case(Login.signUpClick, state => ({
    ...state,
    signUpModal: true
  }))
  .case(Login.signUpClose, state => ({
    ...state,
    signUpModal: false
  }))
  .case(Login.signUp.started, state => ({
    ...state,
    signUpLoading: true
  }))
  .case(Login.signUp.done, (state, payload) => ({
    ...state,
    signUpLoading: false,
    signUpModal: false,
    user: payload.result
  }))
  .case(Login.signUp.failed, (state, { error }) => ({
    ...state,
    signUpLoading: false,
    signUpErrors: error
  }))
  .case(Login.login.started, state => ({
    ...state,
    loginLoading: true
  }))
  .case(Login.login.done, (state, payload) => ({
    ...state,
    loginLoading: false,
    loginModal: false,
    user: payload.result.user
  }))
  .case(Login.login.failed, (state, { error }) => ({
    ...state,
    loginLoading: false,
    loginErrors: error
  }))
  .case(Toolbar.signUpPromoteTapped, state => ({
    ...state,
    signUpModal: true
  }))
  .build()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/login.ts